import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccountSettingsPage from './AccountSettingsPage/AccountSettingsPage';
import DeleteAccountPage from './DeleteAccountPage/DeleteAccountPage';

const AccountSettingsFeature = () => (
  <Switch>
    <Route path="/maps/settings/account" exact>
      <AccountSettingsPage />
    </Route>
    <Route path="/maps/settings/account/delete" exact>
      <DeleteAccountPage />
    </Route>
  </Switch>
);

export default AccountSettingsFeature;
